import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import {
  AfterViewChecked,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { forkJoin } from '@node_modules/rxjs';
import {
  ActivitiesServiceProxy,
  ActivityDaysServiceProxy,
  VarianceFromPlanReasonsServiceProxy,
} from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-activities-drawer',
  templateUrl: './activities-drawer.component.html',
  styleUrls:['./activities-drawer.component.scss']
})
export class ActivitiesDrawerComponent
  extends AppComponentBase
  implements OnInit, AfterViewChecked
{
  @Input() activityData;
  @Input() cloneModal;
  @Input() context: 'allocation' | null;
  @Input() allowedPersonnel;
  @Input() allowedPlants;
  @Input() variancesFromPlanReasons;
  @Input() assetsToBeAssigned;
  @Input() allowedMaterials;
  @Output() openAllocationDrawer: EventEmitter<any> = new EventEmitter<any>();
  @Output() refreshData: EventEmitter<any> = new EventEmitter<any>();

  activitiesEditCanvas;
  activitiesCreateCanvas;
  availableFormsCanvas;
//   openSelectedFormCanvas;

  createFormVisible = false;
  dataLoaded = false;
  showAvailableForms = false;
  showSelectedForm = true;
  isCreation: boolean = false;
//   selectedForm;
//   activityName;
//   activityDate;
//   formData;
  constructor(
    injector: Injector,
    private _activityDaysServiceProxy: ActivityDaysServiceProxy,
    private _activitiesServiceProxy: ActivitiesServiceProxy,
    private _varianceFromPlanServiceProxy: VarianceFromPlanReasonsServiceProxy,
    private _projectService: ProjectService
  ) {
    super(injector);
  }

  ngAfterViewChecked() {
    // edit (assign) drawer
    this.activitiesEditCanvas = new KTOffcanvas(
      'kt_allocation-assign__drawer',
      {
        overlay: true,
        baseClass: 'offcanvas',
        placement: 'right',
        closeBy: 'kt_allocation-sheet__drawer_close',
        toggleBy: 'kt_allocation-assign__drawer_toggle',
      }
    );

    this.activitiesEditCanvas.events.push(
      {
        name: 'beforeShow',
        handler: () => {
          document.querySelector('body').classList.add('overflowed');
        },
      },
      {
        name: 'beforeHide',
        handler: () => {
          document.querySelector('body').classList.remove('overflowed');
        },
      }
    );

    this.activitiesEditCanvas.events.push({
      name: 'afterHide',
      handler: () => {
        this.dataLoaded = false;
        // this.getEnrolledActivityDays();
        abp.event.trigger('evt.refreshAllowedActions');
        abp.event.trigger('app.evt.clearSelectedActivityId');
      },
    });
    // availableFormsCanvas drawer
    this.availableFormsCanvas = new KTOffcanvas('kt_show_forms__drawer', {
      overlay: true,
      baseClass: 'offcanvas',
      placement: 'right',
      closeBy: 'kt_allocation-create__drawer_close',
      toggleBy: 'kt_open_listforms_drawer',
    });

    this.availableFormsCanvas.events.push(
      {
        name: 'afterShow',
        handler: () => {
          this.showAvailableForms = true;
        },
      },
      {
        name: 'beforeShow',
        handler: () => {
          document.querySelector('body').classList.add('overflowed');
        },
      },
      {
        name: 'beforeHide',
        handler: () => {
          document.querySelector('body').classList.remove('overflowed');
        },
      }
    );

    this.availableFormsCanvas.events.push({
      name: 'afterHide',
      handler: () => {
        this.showAvailableForms = false;
      },
    });

    // openSelectedFormCanvas drawer
    // this.openSelectedFormCanvas = new KTOffcanvas('kt_selected_form__drawer', {
    //   overlay: true,
    //   baseClass: 'offcanvas',
    //   placement: 'right',
    //   closeBy: 'kt_allocation-create__drawer_close',
    //   toggleBy: 'kt_open_selected_form_drawer',
    // });

    // this.openSelectedFormCanvas.events.push(
    //   {
    //     name: 'afterShow',
    //     handler: () => {
    //       this.showSelectedForm = true;
    //     },
    //   },
    //   {
    //     name: 'beforeShow',
    //     handler: () => {
    //       document.querySelector('body').classList.add('overflowed');
    //     },
    //   },
    //   {
    //     name: 'beforeHide',
    //     handler: () => {
    //       document.querySelector('body').classList.remove('overflowed');
    //     },
    //   }
    // );

    // this.openSelectedFormCanvas.events.push({
    //   name: 'afterHide',
    //   handler: () => {
    //     this.showSelectedForm = false;
    //   },
    // });

    // create drawer
    this.activitiesCreateCanvas = new KTOffcanvas(
      'kt_allocation-create__drawer',
      {
        overlay: true,
        baseClass: 'offcanvas',
        placement: 'right',
        closeBy: 'kt_allocation-create__drawer_close',
        toggleBy: 'kt_open_create_drawer',
      }
    );

    this.activitiesCreateCanvas.events.push(
      {
        name: 'afterShow',
        handler: () => {
          this.createFormVisible = true;
        },
      },
      {
        name: 'beforeShow',
        handler: () => {
          document.querySelector('body').classList.add('overflowed');
        },
      },
      {
        name: 'beforeHide',
        handler: () => {
          document.querySelector('body').classList.remove('overflowed');
        },
      }
    );

    this.activitiesCreateCanvas.events.push({
      name: 'afterHide',
      handler: () => {
        this.createFormVisible = false;
      },
    });
  }

  ngOnInit(): void {
    abp.event.on('app.evt.openAssignPanel', (data) => {
      this.activitiesCreateCanvas.hide();
      this.openEdit(data.activityDayId);
    });

    // abp.event.on(
    //   'app.evt.openDynamicForm',
    //   (activityName, date, selectedForms, formData) => {
    //     this.activitiesCreateCanvas.hide();
    //     this.openDynamicEdit(
    //       activityName,
    //       date,
    //       selectedForms,
    //       formData,
    //     );
    //   }
    // );
  }

//   async openDynamicEdit(
//     activityName,
//     date,
//     selectedForms,
//     formData,
//   ) {
//     this.selectedForm = selectedForms;
//     this.activityName = activityName;
//     this.activityDate = date;
//     this.formData = formData;
//     // this.openSelectedFormCanvas.show();
//   }

  async openEdit(activityDayId: string) {
    const editData = forkJoin({
      activityDayForEdit:
        this._activityDaysServiceProxy.getMyActivityDayForEdit(activityDayId),
      allowedPersonnel:
        this._activitiesServiceProxy.getPersonnelAllowedToBeAllocated(
          null,
          null,
          null,
          null,
          null,
          0,
          999999
        ),
      allowedPlants:
        this._activityDaysServiceProxy.getPlantsAllowedToBeAllocated(
          null,
          null,
          null,
          null,
          null,
          0,
          999999
        ),
      allowedMaterials:
        this._activityDaysServiceProxy.getMaterialsAllowedToBeAllocated(
          null,
          null,
          null,
          null,
          null,
          0,
          999999
        ),
      variancesFromPlanReasons: this._varianceFromPlanServiceProxy.getAll(
        null,
        null,
        null,
        null,
        0,
        999999
      ),
      assetsToBeAssigned:
        this._activityDaysServiceProxy.getAllAssetsToBeAssigned(
          null,
          null,
          null,
          null,
          0,
          99999
        ),
    });

    editData.subscribe((data) => {
      this.activityData = data.activityDayForEdit.activityDay;

      this.allowedPersonnel = data.allowedPersonnel.items;
      this.allowedPlants = data.allowedPlants.items;
      this.allowedMaterials = data.allowedMaterials.items;
      this.variancesFromPlanReasons = data.variancesFromPlanReasons.items;
      this.assetsToBeAssigned = data.assetsToBeAssigned.items;

      this.dataLoaded = true;

      this.activitiesEditCanvas.show();
    });
  }

  activityCreated() {
    this.refreshData.emit();
  }
  openDefaultActivityForm() {
    this.activitiesCreateCanvas.show();
    this.availableFormsCanvas.hide();
  }
  
  openFormPanel() {
    this.availableFormsCanvas.show();
    this.activitiesCreateCanvas.hide();
  }

//   activityEdited(){
//     this.refreshData.emit();
//   }

  closeDrawer() {
    this.activitiesEditCanvas.hide();
    this.activitiesCreateCanvas.hide();
    this.availableFormsCanvas.hide();
    // this.openSelectedFormCanvas.hide();
  }

  refreshList() {
    this.refreshData.emit();
  }
}
